// @flow
import { normalize } from 'normalizr'
import typeToReducer from 'type-to-reducer'

import { isValidTTL, calculateExpires } from '@alphaott/app-main/selectors'
import categoriesListSchema from '@alphaott/common-utils/utils/schemas/categories'

import type { Genre } from '@alphaott/api-client/types/genres'

import { FETCH_RADIO_CHANNEL_GENRES } from '../../actions/radioChannelGenres'

export type RadioChannelGenresState = {
  +isLoading: boolean,
  +isSuccess: boolean,
  +isError: boolean,
  +result: Array<string>,
  +data: Array<Genre>,
  +expires: ?number,
}

const initialState: RadioChannelGenresState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  errors: [],
  data: [],
  result: [],
  expires: null,
}

const radioChannelGenres = typeToReducer(
  {
    [FETCH_RADIO_CHANNEL_GENRES]: {
      LOADING: (state): RadioChannelGenresState => ({ ...state, isLoading: true }),

      SUCCESS: (state, action): RadioChannelGenresState => {
        const {
          meta: { ttl },
        } = action
        // TODO: think about normalize data
        const { result } = normalize(action.payload.data, categoriesListSchema)
        return {
          ...state,
          isLoading: false,
          isSuccess: true,
          data: action.payload.data,
          result,
          ...(isValidTTL(ttl) && { expires: calculateExpires(ttl) }),
        }
      },

      ERROR: (state, action): RadioChannelGenresState => ({
        ...state,
        isLoading: false,
        isSuccess: false,
        isError: true,
        errors: action.payload.error,
        expires: null,
      }),
    },
  },
  initialState,
)

export { radioChannelGenres }
